import { jsx as _jsx } from "react/jsx-runtime";
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { useSelector } from 'react-redux';
import { makeGetDetailInformation, makeGetExpertReviews } from '../../../redux/product/selectors/ProductSelector';
import { useAemConfig } from '@as-react/common-components';
import { concatUrls } from '../../../util/UrlUtil';
const generateReviewSchema = (review) => ({
    '@type': 'Review',
    name: review.title,
    author: {
        '@type': 'Person',
        name: review.expertInfo.firstName,
    },
    description: review.heading,
    reviewBody: review.reviewText,
    positiveNotes: review.pros,
    negativeNotes: review.cons,
});
const ProductLD = props => {
    var _a, _b, _c;
    const detailInformation = useSelector(makeGetDetailInformation());
    const exportReviews = useSelector(makeGetExpertReviews());
    const { canonicalUrl } = useAemConfig();
    if (typeof props.data.brand === 'object' &&
        'url' in props.data.brand &&
        ((_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.url) === null &&
        ((_c = detailInformation === null || detailInformation === void 0 ? void 0 : detailInformation.brand) === null || _c === void 0 ? void 0 : _c.relativePath)) {
        const url = new URL(canonicalUrl);
        props.data.brand.url = concatUrls(url.origin, detailInformation.brand.relativePath);
    }
    if (exportReviews.length > 0) {
        props.data.review =
            exportReviews.length > 1 ? exportReviews.map(generateReviewSchema) : generateReviewSchema(exportReviews[0]);
    }
    const jsonLDScript = `<script type="application/ld+json">${JSON.stringify(props.data)}</script>`;
    return _jsx(HtmlInclude, { htmlFragment: jsonLDScript });
};
export default ProductLD;
